import React, { useState, useEffect } from 'react';
import Hero from '../components/Hero';
import { useLanguage } from '../i18n/LanguageContext';

export default function Payment({result}) {
  const { strings } = useLanguage();
  const [message, setMessage] = useState('');

  useEffect(() => {
    const referrer = document.referrer;
    if (result === 'success') {
      setMessage(strings.pages.payment.successMessage);
    } else if (result === 'cancel') {
      setMessage(strings.pages.payment.cancelMessage);
    }
  }, [strings]);

  return (
    <div className="main">
      <Hero title={strings.pages.payment.title} eyebrow={strings.pages.payment.eyebrow} />
      <main className="page-content">
         <div className="content-table max-centered">
              <div className="content-container">    
                  <div className="content-container-main show" id="content-container-main" >
                     {message}
                  </div>
              </div>
       </div>
      </main>
    </div>
  );
}